var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unscoped-content-block",domProps:{"innerHTML":_vm._s(_vm.$props.htmlText)}})}
var staticRenderFns = []

export { render, staticRenderFns }